import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor() { }

  handleError(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'The server is currently unavailable. Please try again later.';
    }
    switch (error.status) {
      case 404:
        return 'Requested resource not found.';
      case 500:
        return 'Internal server error. Please try again later.';
      case 403:
        return 'You do not have permission to access this resource.';
      case 401:
        return 'Your session has expired. Please log in again.';
      default:
        return 'An unexpected error occurred. Please try again later.';
    }
  }
}
